import { Outlet, useSearchParams } from 'react-router-dom';

import { AppShell } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

import { LayoutProvider, useLayout } from '@/contexts/LayoutContext';
import { Footer } from './Footer';
import { PageAside } from './PageAside';
import { TopNav } from './TopNav';

const ASIDE_WIDTH = 400;

function LayoutShell() {
  const { asideContent, asideTitle, asideOpen, setAsideOpen } = useLayout();
  const hasAside = asideContent !== null;

  return (
    <AppShell
      header={{ height: 60 }}
      aside={
        hasAside
          ? {
              width: ASIDE_WIDTH,
              breakpoint: 'sm',
              collapsed: { desktop: !asideOpen, mobile: !asideOpen },
            }
          : undefined
      }
      padding="md"
      styles={{
        header: {
          backgroundColor: 'var(--mantine-color-navy-9)',
          borderBottom: '3px solid var(--mantine-color-yellow-5)',
          boxShadow: '0 2px 8px rgba(1, 22, 57, 0.1)',
        },
        main: {
          backgroundColor: 'var(--mantine-color-gray-0)',
        },
      }}
    >
      <TopNav />
      <Notifications zIndex={100001} />
      <AppShell.Main>
        <Outlet />
        <Footer />
      </AppShell.Main>
      {hasAside && asideTitle && (
        <PageAside
          title={asideTitle}
          opened={asideOpen}
          onClose={() => setAsideOpen(false)}
          onOpen={() => setAsideOpen(true)}
        >
          {asideContent}
        </PageAside>
      )}
    </AppShell>
  );
}

export function Layout() {
  const [searchParams] = useSearchParams();
  const isPrintMode = searchParams.get('print') === 'true';

  if (isPrintMode) {
    return <Outlet />;
  }

  return (
    <LayoutProvider>
      <LayoutShell />
    </LayoutProvider>
  );
}
